import {Transerializable} from '@eventops/athlinks-get-or'

export interface IIndividualSearchResult {
  bib: string,
  ctLiveEntryId: number,
  firstName: string,
  lastName: string,
  raceId: number,
}

export class IndividualSearchResult extends Transerializable implements IIndividualSearchResult {
  public bib = ''
  public ctLiveEntryId = 0
  public firstName = ''
  public lastName = ''
  public raceId = 0
}

export enum IndividualSearchEntryIdType {
  ID = 'id',
  BIB = 'bib'
}
